import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { saveAddress } from "../../store/feature/addressSlice";

const AddAddress: React.FC = () => {
  const [value, setValue] = useState("");
  const { loading, error } = useSelector((state: RootState) => state.address);
  const dispatch = useDispatch<AppDispatch>();
  const token = localStorage.getItem("token") || "";

  const handleAddAddress = () => {
    if (!value.trim()) {
      alert("Adres değeri boş olamaz!");
      return;
    }

    dispatch(
      saveAddress({
        token,
        value,
        description: "", // Send description as an empty string
      })
    );

    setValue(""); // Clear input after submission
  };

  return (
    <div className="max-w-md mx-auto p-4">
      <h1 className="text-2xl font-bold text-center mb-4">Adres Ekle</h1>
      <div className="bg-white shadow-md rounded-lg p-4">
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Adres Değeri"
          className="w-full border border-gray-300 rounded-lg p-2 mb-4"
        />
        <button
          onClick={handleAddAddress}
          className={`w-full bg-blue-500 text-white py-2 rounded-lg ${
            loading ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-600 transition"
          }`}
          disabled={loading}
        >
          {loading ? "Ekleniyor..." : "Ekle"}
        </button>
        {error && <p className="text-red-500 mt-2 text-center">{error}</p>}
      </div>
    </div>
  );
};

export default AddAddress;
